import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer(props) {
  const { className } = props;

  return (
    <div className={`footer ${className || ""}`}>
      <div className="group-125">
        <div className="flex-row-6">
          <div className="overlap-group2-1">
            <div className="group-25">
              <div className="contact-us-1 poppins-medium-tundora-16px">Contact Us</div>
              <div className="flex-row-7">
                <div className="overlap-group-container">
                  <div className="overlap-group1-1">
                    <img className="vector-12" src="/img/vector-11@2x.png" />
                  </div>
                  <div className="overlap-group-5">
                    <img className="vector-12" src="/img/vector-11@2x.png" />
                  </div>
                </div>
                <div className="flex-col-7 roboto-normal-tundora-12px">
                  <p className="x123-lane-opp-sai">
                    123, lane, opp. Sai Temple
                    <br />
                    Emerald Hills
                    <br />
                    Dehradun- 248001
                  </p>
                  <p className="r-255-2nd-floor">
                    R - 255, 2nd Floor, G K- 1<br />
                    Delhi - 110048
                  </p>
                  <div className="phone">+91-9999963537</div>
                </div>
              </div>
            </div>
            <img className="vector-15" src="/img/vector-8@2x.png" />
          </div>
          <div className="flex-col-8">
            <div className="useful-links poppins-medium-tundora-16px">Useful Links</div>
            <div className="place-1 roboto-normal-tundora-12px">Home</div>
            <div className="flex-col-item roboto-normal-tundora-12px">About Us</div>
            <div className="flex-col-item variant-1 roboto-normal-tundora-12px">Services</div>
            <div className="flex-col-item variant-2 roboto-normal-tundora-12px">Media</div>
            <div className="flex-col-item roboto-normal-tundora-12px">Blog</div>
            <div className="flex-col-item variant-3 roboto-normal-tundora-12px">Gallery</div>
          </div>
        </div>
        <div className="group-container-2">
          <img className="group-91" src="/img/group-91@2x.png" />
          <img className="group-92" src="/img/group-92@2x.png" />
          <img className="group-93" src="/img/group-93@2x.png" />
          <img className="group-94" src="/img/group-94@2x.png" />
        </div>
        <div className="copyrightsohnijunejacom-2 roboto-normal-tundora-12px">copyright@sohnijuneja.com</div>
      </div>
    </div>
  );
}

export default Footer;
